import { render, staticRenderFns } from "./resourcemanage.vue?vue&type=template&id=2fa11552&scoped=true"
import script from "./resourcemanage.vue?vue&type=script&lang=js"
export * from "./resourcemanage.vue?vue&type=script&lang=js"
import style0 from "./resourcemanage.vue?vue&type=style&index=0&id=2fa11552&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa11552",
  null
  
)

export default component.exports